export const getStyles = () => ({
  styles: {
    wrapper: {
      width: 350,
      backgroundColor: "#474747",
      right: 0,
      margin: 0,
      paddingTop: "56px",
      px: "45px",
    },
    button: {
      padding: 0,
      margin: "0 0 32px auto",
      width: "100%",
      justifyContent: "flex-end",
      fontWeight: 500,
    },
  },
});
